/**
 * Auto-generated Zod schema for RepositoryVulnerabilityAlertDismissEvent
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { RepositoryVulnerabilityAlertDismissEvent as RepositoryVulnerabilityAlertDismissEventOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import {
  GitHubOrgSchema,
  OrganizationSchema,
  RepositorySchema,
  RepositoryVulnerabilityAlertAlertSchema,
  UserSchema,
} from './shared/index.js';

export const RepositoryVulnerabilityAlertDismissEventSchema = z.object({
  action: z.literal('dismiss'),
  alert: RepositoryVulnerabilityAlertAlertSchema.and(
    z.object({
      dismisser: UserSchema,
      dismiss_reason: z.string(),
      dismissed_at: z.string(),
      state: z.literal('dismissed'),
    }),
  ),
  repository: RepositorySchema,
  sender: GitHubOrgSchema,
  organization: OrganizationSchema.optional(),
}) satisfies z.ZodType<RepositoryVulnerabilityAlertDismissEventOctokit>;

export type RepositoryVulnerabilityAlertDismissEvent =
  RepositoryVulnerabilityAlertDismissEventOctokit;

export function isRepositoryVulnerabilityAlertDismissEvent(
  value: unknown,
): value is RepositoryVulnerabilityAlertDismissEvent {
  return RepositoryVulnerabilityAlertDismissEventSchema.safeParse(value).success;
}
